// Hierarchy Admin
export const CancelDraft = "CANCEL_DRAFT";
export const DeleteBranch = "DELETE_BRANCH";
export const DiscardDraft = "DISCARD_DRAFT";
export const DiscardDraftSuccess = "DISCARD_DRAFT_SUCCESS";
export const DiscardDraftError = "DISCARD_DRAFT_ERROR";
export const DeleteBranchSuccess = "DELETE_BRANCH_SUCCESS";
export const DeleteBranchError = "DELETE_BRANCH_ERROR";
export const GetActiveHierarchyTree = "GET_ACTIVE_HIERARCHY_TREE";
export const GetActiveHierarchyTreeCsv = "GET_ACTIVE_HIERARCHY_TREE_CSV";
export const GetActiveHierarchyTreeSuccess = "GET_ACTIVE_HIERARCHY_TREE_SUCCESS";
export const GetActiveHierarchyTreeError = "GET_ACTIVE_HIERARCHY_TREE_ERROR";
export const GetDraftHierarchyTree = "GET_DRAFT_HIERARCHY_TREE";
export const GetDraftHierarchyTreeChangelog = "GET_DRAFT_HIERARCHY_TREE_CHANGELOG";
export const GetDraftHierarchyTreeChangelogSuccess = "GET_DRAFT_HIERARCHY_TREE_CHANGELOG_SUCCESS";
export const GetDraftHierarchyTreeChangelogError = "GET_DRAFT_HIERARCHY_TREE_CHANGELOG_ERROR";
export const GetDraftHierarchyTreeCsv = "GET_DRAFT_HIERARCHY_TREE_CSV";
export const GetDraftHierarchyTreeSuccess = "GET_DRAFT_HIERARCHY_TREE_SUCCESS";
export const GetDraftHierarchyTreeError = "GET_DRAFT_HIERARCHY_TREE_ERROR";
export const MoveBranch = "MOVE_BRANCH";
export const MoveBranchSuccess = "MOVE_BRANCH_SUCCESS";
export const MoveBranchError = "MOVE_BRANCH_ERROR";
export const RenameBranch = "RENAME_BRANCH";
export const RenameBranchSuccess = "RENAME_BRANCH_SUCCESS";
export const RenameBranchError = "RENAME_BRANCH_ERROR";
export const SaveDraftHierarchyTree = "SAVE_DRAFT_HIERARCHY_TREE";
export const SubmitDraftHierarchyTree = "SUBMIT'_DRAFT_HIERARCHY_TREE";
export const ViewScopeChanges = "VIEW_SCOPE_CHANGES";
export const ViewScopeChangesSuccess = "VIEW_SCOPE_CHANGES_SUCCESS";
export const ViewScopeChangesError = "VIEW_SCOPE_CHANGES_ERROR";
export const ToggleEditDraftHierarchyModal = "TOGGLE_EDIT_DRAFT_HIERARCHY_MODAL";
export const SelectOrganizationalUnit = "SELECT_ORGANIZATIONAL_UNIT";
export const GetNotificationContacts = "GET_HIERARCHY_NOTIFICATION_CONTACTS";
export const GetHierarchyNotificationContactsSuccess =
  "GET_HIERARCHY_NOTIFICATION_CONTACTS_SUCCESS";
export const GetNotificationContactsError = "GET_HIERARCHY_NOTIFICATION_CONTACTS_ERROR";
export const GetHierarchyShiftPatterns = "GET_HIERARCHY_SHIFT_PATTERNS";
export const GetHierarchyShiftPatternsSuccess = "GET_HIERARCHY_SHIFT_PATTERNS_SUCCESS";
export const GetHierarchyShiftPatternsError = "GET_HIERARCHY_SHIFT_PATTERNS_ERROR";
export const GetHierarchyNotificationsSummary = "GET_HIERARCHY_NOTIFICATIONS_SUMMARY";
export const GetHierarchyNotificationsSummarySuccess =
  "GET_HIERARCHY_NOTIFICATIONS_SUMMARY_SUCCESS";
export const GetHierarchyNotificationsSummaryError = "GET_HIERARCHY_NOTIFICATIONS_SUMMARY_ERROR";
export const ToggleAddEditShiftPatternModal = "TOGGLE_ADD_EDIT_SHIFT_PATTERN_MODAL";
export const ToggleAddEditContactModal = "TOGGLE_ADD_EDIT_CONTACT_MODAL";
export const SetNotificationContact = "SET_NOTIFICATION_CONTACT";
export const CreateHierarchyNotification = "CREATE_HIERARCHY_NOTIFICATION";
export const CreateHierarchyNotificationSuccess = "CREATE_HIERARCHY_NOTIFICATION_SUCCES";
export const CreateHierarchyNotificationError = "CREATE_HIERARCHY_NOTIFICATION_ERROR";
export const UpdateHierarchyNotification = "UPDATE_HIERARCHY_NOTIFICATION";
export const UpdateHierarchyNotificationSuccess = "UPDATE_HIERARCHY_NOTIFICATION_SUCCES";
export const UpdateHierarchyNotificationError = "UPDATE_HIERARCHY_NOTIFICATION_ERROR";
export const GetHierarchyShiftPatternSchema = "GET_HIERARCHY_SHIFT_PATTERN_SCHEMA";
export const GetHierarchyShiftPatternSchemaSuccess = "GET_HIERARCHY_SHIFT_PATTERN_SCHEMA_SUCCESS";
export const GetHierarchyShiftPatternSchemaError = "GET_HIERARCHY_SHIFT_PATTERN_SCHEMA_ERROR";
export const CreateHierarchyShiftPattern = "CREATE_HIERARCHY_SHIFT_PATTERN";
export const CreateHierarchyShiftPatternSuccess = "CREATE_HIERARCHY_SHIFT_PATTERN_SUCCESS";
export const CreateHierarchyShiftPatternError = "CREATE_HIERARCHY_SHIFT_PATTERN_ERROR";
export const UpdateHierarchyShiftPattern = "UPDATE_HIERARCHY_SHIFT_PATTERN";
export const UpdateHierarchyShiftPatternSuccess = "UPDATE_HIERARCHY_SHIFT_PATTERN_SUCCESS";
export const UpdateHierarchyShiftPatternError = "UPDATE_HIERARCHY_SHIFT_PATTERN_ERROR";
export const ToggleHierarchySidebar = "TOGGLE_HIERARCHY_SIDEBAR";

// Change log
export const GetHierarchyChangelog = "GET_HIERARCHY_CHANGELOG";
export const GetHierarchyChangelogSuccess = "GET_HIERARCHY_CHANGELOG_SUCCESS";
export const GetHierarchyChangelogError = "GET_HIERARCHY_CHANGELOG_ERROR";
export const ExportHierarchyChangelog = "EXPORT_HIERARCHY_CHANGELOG";
export const ExportHierarchyChangelogSuccess = "EXPORT_HIERARCHY_CHANGELOG_SUCCESS";
export const ExportHierarchyChangelogError = "EXPORT_HIERARCHY_CHANGELOG_ERROR";
export const GetHierarchyChangelogUsers = "GET_HIERARCHY_CHANGELOG_USERS";
export const GetHierarchyChangelogUsersSuccess = "GET_HIERARCHY_CHANGELOG_USERS_SUCCESS";
export const GetHierarchyChangelogUsersError = "GET_HIERARCHY_CHANGELOG_USERS_ERROR";

// Department Contacts
export const ExportFullList = "EXPORT_FULL_LIST";
export const ExportFullListSuccess = "EXPORT_FULL_LIST_SUCCESS";
export const ExportFullListError = "EXPORT_FULL_LIST_ERROR";

//Hierarchi Changes
export const ExportSimpleList = "EXPORT_SIMPLE_LIST";
export const ExportSimpleListSuccess = "EXPORT_SIMPLE_LIST_SUCCESS";
export const ExportSimpleListError = "EXPORT_SIMPLE_LIST_ERROR";

export const CutDepartment = "CUT_DEPARTMENT";
export const CutDepartmentError = "CUT_DEPARTMENT_ERROR";
export const DeleteDepartmentError = "DELETE_DEPARTMENT_ERROR";
